export const MIN_BPM = 60;
export const MAX_BPM = 200;
export const DEFAULT_BPM_RANGE = { low: MIN_BPM, high: MAX_BPM };
